export class HubPlace {
  public _id: string;
  public id: string;
  public nameId?: string;
  public hubName: string;
  public feedId: string;
  public isApproved: boolean;
  public isOwned: boolean;
  public isBlocked: boolean;
  public isNotExistInSource: boolean; // a place might be removed from Google, this indicates if it is removed
  public isPermanentlyClosed: boolean;
  public lat: number;
  public lng: number;
  public likes: number;
  public checkins: number;
  public rating: number;
  public user_ratings_total: number;
  public business_status: PlaceBusinessStatus; // for google places, stands for if the place is open normally (OPERATIONAL), or CLOSED_TEMPORARILY or CLOSED_PERMANENTLY
  public title: string;
  public name: string;
  public phone: string;
  public emails: string;
  public category: string;
  public categoryText?: string;
  public priceRange: string;
  public website: string;
  public categoryList: string[];
  public blacklisted: boolean;

  public image?: string;
  public imageLink?: string;
  public imageFile: File;
  public _360VideoKey?: string;
  public youtubeLink?: string;
  public facebookLink?: string;
  public address?: {
    address: string;
    lat: number;
    lng: number;
    address_components: any;
  };
  public address_components?: {
    long_name: string;
    short_name: string;
    types: string[];
  }[];
  public attendingCount?: number;
  public isChoice?: boolean;
  public isCustom?: boolean;
  public isToBeExport?: boolean;
  public pinnedTime: Date;

  public hostFacebookLink?: string;
  public hostGoogleLink?: string;
  public ticketUri?: string;
  public description?: string;
  public about?: string;

  public owner: {
    name: string;
  };
  public startTimeFormatted: string;
  public endTimeFormatted: string;
  public isManuallyCreated: boolean;
  public isPromotionImage: boolean;
  public isFacebookEvent: boolean;
  public hostLink: string;
  public ownerEmail: string;
  public ownerPhone: string;
  public eventLink: string;
  public promotionLink: string;
  public cover: {
    source: string;
    isDefault: boolean;
  };

  public startTime?: string;
  public endTime?: string;
  public eventTimes?: any[];
  public startTimeText?: string;
  public endTimeText?: string;
  public eventTimesText?: any[];
  public timezone?: string;
  public mapIcon?: string;
  public hours?: any[];
  public hoursText?: any[];

  public placeId?: string;
  public from?: string;
  public socialName?: string;

  public photos: {
    photo_reference: string; // for google places
  }[];
  public blockedGooglePhotos: string[];
  public allowedGooglePhotos: string[];
  public ownedPhotos: string[];

  public changeHistory: {
    userName: string;
    changedAt: string;
  }[];

  // for V3 places, some new fields from Google places
  public wheelchair_accessible_entrance: boolean;
  public dine: {
    delivery: boolean | undefined;
    dine_in: boolean | undefined;
    serves_beer: boolean | undefined;
    serves_breakfast: boolean | undefined;
    serves_brunch: boolean | undefined;
    serves_dinner: boolean | undefined;
    serves_lunch: boolean | undefined;
    serves_wine: boolean | undefined;
    takeout: boolean | undefined;
    curbside_pickup: boolean | undefined;
  };

  // provide client a function that they can edit place info, and lock them so that they can't be refreshed when updating the place from Google
  public lock: {
    name: boolean;
    description: boolean;
    category: boolean;
    address: boolean;
    website: boolean;
    phone: boolean;
    priceRange: boolean;
    business_status: boolean;
    services: boolean;
  };
  public audio: {
    link: string;
    description: string;
    isActive: boolean;
  }
}

export enum PlaceBusinessStatus {
  OPERATIONAL = 'OPERATIONAL',
  CLOSED_TEMPORARILY = 'CLOSED_TEMPORARILY',
  CLOSED_PERMANENTLY = 'CLOSED_PERMANENTLY',
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/models/hub/hub.place.ts